function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#343A40",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.934 17.414a3.43 3.43 0 01-2.389 5.991h-.229a3.43 3.43 0 11.229-6.857h.217c.184.006.365.026.54.06l-.026-.06L12.128 0C12.5 0 13.5 1.5 11.5 5.5L5.934 17.414zm-2.39.803v.046a1.715 1.715 0 10-.114 3.428h.115a1.726 1.726 0 001.714-1.6 1.76 1.76 0 00-.457-1.291 1.749 1.749 0 00-1.143-.583h-.114z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.775 17.414a3.43 3.43 0 002.389 5.991h.229a3.43 3.43 0 10-.229-6.857h-.217a3.456 3.456 0 00-.54.06l.026-.06L4.58 0C4.21 0 3.21 1.5 5.21 5.5l5.566 11.914zm2.389.803v.046a1.715 1.715 0 11.114 3.428h-.114a1.726 1.726 0 01-1.714-1.6 1.76 1.76 0 01.457-1.291c.293-.332.702-.54 1.143-.583h.114z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 24"
  }, props), _ref);
};

export default SvgComponent;